interface ChipProps {
  label: string;
  selected: boolean;
  onToggle: () => void;
}

/** A toggleable filter chip (multi-select). Communicates state via aria-pressed. */
export function Chip({ label, selected, onToggle }: ChipProps): JSX.Element {
  return (
    <button
      type="button"
      className={`chip${selected ? ' chip--selected' : ''}`}
      aria-pressed={selected}
      onClick={onToggle}
    >
      {label}
    </button>
  );
}
